import axios from '@/utils/api'
import { getTranslationsFallback } from '@/utils/helpers'
import { setupCheckoutSymbols } from '@/utils/setGlobalProperties'
import { watchIsMobile } from '@/utils/device'
import { applyCountryAndCurrency } from '@/utils/countryAndCurrency'
import parsePhoneNumber from 'libphonenumber-js'
import * as Sentry from '@sentry/vue'
import {
  isInPolygonMsk,
  isInPolygonSpb,
  isInPolygonKiev,
  getCourierMskZone,
} from '@/utils/geoZones'
import * as checkoutAnalytics from '@/utils/checkoutAnalytics'
import { perfTrace } from '@/utils/perfMarks'

export async function bootApp(app, store) {
  const translations =
    window.translations ??
    (await perfTrace('init:translations', () => getTranslationsFallback()))

  app.config.globalProperties.$t = (key) => translations?.[key]
  app.config.globalProperties.$axios = axios
  applyCountryAndCurrency(store)
  watchIsMobile(app)

  checkoutAnalytics.getBatchOrderingId()
  app.config.globalProperties.$checkoutAnalytics = checkoutAnalytics

  const countryCode = store?.state?.country?.code || 'RU'
  app.config.globalProperties.$countries = window.countries || {}

  app.config.globalProperties.$formatPhone = (input) => {
    if (!input) return input
    try {
      const phoneNumber = parsePhoneNumber(input, countryCode.toUpperCase())
      return phoneNumber.formatNational()
    } catch (err) {
      return input
    }
  }

  // Функции проверки зоны на карте
  app.config.globalProperties.$isObjectInPolygonMsk = isInPolygonMsk
  app.config.globalProperties.$isObjectInPolygonSpb = isInPolygonSpb
  app.config.globalProperties.$isObjectInPolygonKiev = isInPolygonKiev
  app.config.globalProperties.$courierMskZone = getCourierMskZone

  // GET /init — главный блокирующий запрос
  let checkoutOptions
  try {
    checkoutOptions = await perfTrace('init:request', () =>
      store.dispatch('GET_INITIAL_DATA')
    )

    if (!checkoutOptions || !Object.keys(checkoutOptions).length) {
      const sentryEventId = Sentry.captureMessage(
        'checkoutOptions is empty or invalid'
      )
      checkoutAnalytics.trackCheckoutError({
        step: 'delivery',
        errorType: 'checkout.init.empty_options',
        errorMessage: 'checkoutOptions is empty or invalid',
        sentryEventId,
      })
    }
    app.config.globalProperties.$checkoutOptions = checkoutOptions
    store.dispatch('GET_BASKET')
  } catch (error) {
    console.error('bootApp GET_INITIAL_DATA error:', error)
    const sentryEventId = Sentry.captureException(error)
    checkoutAnalytics.trackCheckoutError({
      step: 'delivery',
      errorType: 'checkout.init.failed',
      errorMessage: error?.message || 'GET_INITIAL_DATA failed',
      sentryEventId,
    })
    app.config.globalProperties.$initError = error
    return
  }

  perfTrace('init:post-process', () => {
    app.config.globalProperties.$noCityChangeCountries =
      checkoutOptions?.noCityChangeCountries || []
    app.config.globalProperties.$countriesNoLimit =
      checkoutOptions?.countriesNoLimit || []
    app.config.globalProperties.$moscowDeliveryTimes =
      checkoutOptions?.moscowDeliveryTimes || []
    app.config.globalProperties.$spbDeliveryTimes =
      checkoutOptions?.spbDeliveryTimes || []

    setupCheckoutSymbols(app, store, checkoutOptions)
  })
}
